const YEAR_IN_REVIEW_2020 = "year-in-review/2020";
export const DYNAMIC_ASSET_PARAM_PATHS = [
    {
        value: YEAR_IN_REVIEW_2020,
        text: "Year In Review 2020"
    }
];
